import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login'
import { GoogleLoginProvider, FacebookLoginProvider, GoogleInitOptions } from '@abacritt/angularx-social-login'
import { environment } from 'apps/gb-front/src/environments/environment'

const googleLoginOptions: GoogleInitOptions = {
  oneTapEnabled: false, // default is true
  scopes: 'email profile openid',
} // https://developers.google.com/identity/oauth2/web/guides/use-token-model#initialize_a_token_client

const fbLoginOptions = {
  scope: 'email',
  return_scopes: true,
  enable_profile_selector: true,
} // https://developers.facebook.com/docs/reference/javascript/FB.login/v2.11

@NgModule({
  imports: [CommonModule, SocialLoginModule],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleOauthClientId, googleLoginOptions),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.facebookAppId, fbLoginOptions),
          },
        ],
        onError: (err) => {
          console.error(err)
        },
      } as SocialAuthServiceConfig,
    },
  ],
})
export class GbFrontSharedSocialLoginModule {}
